import React, { useState, useRef, useEffect } from 'react';
import { Play, X, Volume2, VolumeX } from 'lucide-react';

const VIDEO_MOBILE = `${process.env.PUBLIC_URL}/videos/mobile-promo.mp4`;
const VIDEO_DESKTOP = `${process.env.PUBLIC_URL}/videos/desktop-promo.mp4`;

const PromoVideo = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [muted, setMuted] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    if (videoRef.current) videoRef.current.pause();
  };

  const toggleMute = (e) => {
    e.stopPropagation();
    setMuted(!muted);
    if (videoRef.current) videoRef.current.muted = !muted;
  };

  // ====== MOBILE: Inline collapsible ======
  if (isMobile) {
    if (isOpen) {
      return (
        <div className="mb-4 mx-auto max-w-sm">
          <div className="relative rounded-xl overflow-hidden shadow-lg border border-gray-200 bg-black">
            <button onClick={handleClose} className="absolute top-2 right-2 z-10 w-7 h-7 bg-black/60 rounded-full flex items-center justify-center">
              <X className="w-3.5 h-3.5 text-white" />
            </button>
            <video ref={videoRef} className="w-full max-h-[50vh]" controls autoPlay playsInline muted={muted} preload="metadata">
              <source src={VIDEO_MOBILE} type="video/mp4" />
            </video>
          </div>
        </div>
      );
    }
    return (
      <div className="mb-4 flex justify-center">
        <button data-testid="play-video-btn" onClick={() => setIsOpen(true)} className="group flex items-center gap-2 px-4 py-2 bg-white border-2 border-stocker-green/30 hover:border-stocker-green rounded-full shadow-sm transition-all">
          <div className="w-7 h-7 bg-stocker-green rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
            <Play className="w-3.5 h-3.5 text-white fill-white ml-0.5" />
          </div>
          <span className="text-xs font-semibold text-gray-700">Guarda il video</span>
          <span className="text-[10px] text-gray-400">0:48</span>
        </button>
      </div>
    );
  }

  // ====== DESKTOP: Sticky right sidebar ======
  if (isOpen) {
    return (
      <div className="fixed right-4 top-1/2 -translate-y-1/2 z-30 w-72 rounded-xl overflow-hidden shadow-2xl border border-gray-200 bg-black">
        <div className="relative">
          <div className="absolute top-2 right-2 z-10 flex gap-1.5">
            <button onClick={toggleMute} className="w-7 h-7 bg-black/60 hover:bg-black/80 rounded-full flex items-center justify-center">
              {muted ? <VolumeX className="w-3.5 h-3.5 text-white" /> : <Volume2 className="w-3.5 h-3.5 text-white" />}
            </button>
            <button onClick={handleClose} className="w-7 h-7 bg-black/60 hover:bg-black/80 rounded-full flex items-center justify-center">
              <X className="w-3.5 h-3.5 text-white" />
            </button>
          </div>
          <video ref={videoRef} className="w-full" autoPlay loop playsInline muted={muted} preload="metadata">
            <source src={VIDEO_DESKTOP} type="video/mp4" />
          </video>
        </div>
        <div className="bg-gradient-to-t from-black/80 to-transparent absolute bottom-0 left-0 right-0 p-3">
          <p className="text-white text-[11px] font-medium">Geyser PRO – Antizanzare</p>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed right-4 top-1/2 -translate-y-1/2 z-30">
      <button
        data-testid="play-video-btn"
        onClick={() => setIsOpen(true)}
        className="group flex flex-col items-center gap-2 p-3 bg-white border-2 border-stocker-green/30 hover:border-stocker-green rounded-xl shadow-lg hover:shadow-xl transition-all"
      >
        <div className="w-12 h-12 bg-stocker-green rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
          <Play className="w-6 h-6 text-white fill-white ml-0.5" />
        </div>
        <div className="text-center">
          <p className="text-[11px] font-bold text-gray-700">Video</p>
          <p className="text-[10px] text-gray-400">0:48</p>
        </div>
      </button>
    </div>
  );
};

export default PromoVideo;
